<template>
  <div>
    <div class="third-sub-nav">
      <ul class="sub-nav-box clearfix">
        <li
          v-for="(nav, index) in navList"
          :key="index"
          class="sub-nav-item"
          :class="{
            pre: nav.targetRouterName === $route.name,
          }"
        >
          <nav-link-item
            sub
            :nav="nav"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import NavLinkItem from './components/NavLinkItem';

export default {
  components: { NavLinkItem },
  props: {
    navList: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.third-sub-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 0.5rem;
  padding-left: .24rem;
  box-sizing: border-box;
  margin: 0 0 .18rem 0;
  .sub-nav-box {
    width: auto;
    display: flex;
    align-items: center;
    font-size: 0.2rem;
    box-sizing: border-box;
    height: .5rem;
    position: relative;

    .sub-nav-item {
      width: 1.54rem;
      height: .4rem;
      text-align: center;
      margin: 0;
      line-height: 0.4rem;

      & /deep/ .nav-link-item {
        .red-point {
          top: -0.05rem;
          right: -0.14rem;
        }
      }

      a {
        font-size: .22rem;
        color: #fff;
        width: 1.54rem;
        height: .4rem;
        display: block;
        box-sizing: border-box;
      }

      &.pre {
        a {
          background: url(~@img/bbgl-tab.png) no-repeat center/cover;
        }
      }
    }
  }
}
  .third-more{
    .third-sub-nav{
      .sub-nav-box{
        background: none;
        border: none;
        .sub-nav-item{
          background: rgba(76, 82, 95, .45);
          border: 1px solid #b2b4b7;
          height: .5rem;
          line-height: .5rem;
          margin: 0 .25rem 0 0;
          a{
            color: #fff;
            padding: 0 .25rem;
            box-sizing: border-box;
            display: block;
            font-size: .24rem;
          }
          &.pre{
            background: rgba(118,57,16,.5);
            border: 1px solid #f09e35;
          }
        }
      }
    }
  }
</style>
